import { BackgroundIcon } from "../assets/svg/BackgroundIcon";
import { BedIcon } from "../assets/svg/BedIcon";
import { ChairIcon } from "../assets/svg/ChairIcon";
import { DecorIcon } from "../assets/svg/DecorIcon";
import { FloorIcon } from "../assets/svg/FloorIcon";
import { LightIcon } from "../assets/svg/LightIcon";
import { PlantIcon } from "../assets/svg/PlantIcon";
import { RoomIcon } from "../assets/svg/RoomIcon";
import { StorageIcon } from "../assets/svg/StorageIcon";
import { TableIcon } from "../assets/svg/TableIcon";
import { WallIcon } from "../assets/svg/WallIcon";
import { ActionButton } from "../shared/ActionButton/ActionButton";
import { DropdownButton } from "../shared/DropdownButton/DropdownButton";
import { SofaIcon } from "./../assets/svg/SofaIcon";
import {
  categoryDataT,
  dataBackground,
  dataBed,
  dataChair,
  dataDecor,
  dataFloor,
  dataLight,
  dataPlant,
  dataRoom,
  dataSofa,
  dataStorage,
  dataTable,
  dataWall,
} from "./categoriesData";
export const TYPE_REDUCER = {
  SET_MODAL: "set modal status",
  SET_ACTIVE_TAB: "set active tab",
  SET_SELECTED_MODEL: "selected Model",
  SET_WEBSOCKET_CONNECTED: "set Ws Connected",
  SET_RENDER_HASH: "set Render Hash",
  SET_PRODUCTS: "set products",
  SET_CATEGORIES: "set categories",
  SET_SERVER_STATUS: "set server status",
  SET_ENVIRONMENTS: "set env",
  SET_ENVIRONMENT_VARIANT: "set env value",
};
export const apiAssets = "https://scooterapi.3dconfiguration.com/files/test/";

export type categoryId =
  | "sofa"
  | "bed"
  | "storage"
  | "table"
  | "chair"
  | "light"
  | "plant"
  | "decor"
  | "room"
  | "Wall"
  | "Floor"
  | "Background";

export type filterT = "Black color" | "White color";
export type categoryesListT = {
  type: "environment" | "interior";
  id: categoryId;
  icon?: any;
  img?: any;
  label: string;
  data: categoryDataT[];
  search?: boolean;
  filter?: filterT[];
  sort?: boolean;
};

export type cameraListT = {
  value: any;
  label: string;
  id: number;
};

export type resolutionListT = {
  value: any;
  label: string;
  id: number;
};

export const staticEnvironments = ["Wall", "Floor", "Background"];
export const cameraList: cameraListT[] = [
  {
    value: {
      pos: { x: 2.69645, y: 2.32062, z: 1.32439 },
      rot: { x: -23.69999999999998, y: 60.35, z: -1.449999999999993 },
    },
    label: "Camera Preset 1",
    id: 0,
  },
  {
    value: {
      pos: {
        x: -1.1763838643261164,
        y: 2.8664114380677757,
        z: -1.0825253911422594,
      },
      rot: {
        x: -89.99277552207256,
        y: 72.63801374383216,
        z: 1.0658423086412726e-14,
      },
    },
    label: "Camera Preset 2",
    id: 1,
  },
  {
    value: {
      pos: {
        x: -4.335934489861157,
        y: 1.8792639102980124,
        z: -5.102128756538293,
      },
      rot: { x: 167.76166826153653, y: -52.35421555388755, z: 180 },
    },
    label: "Camera Preset 3",
    id: 2,
  },
];
export const categoryesList: categoryesListT[] = [
  {
    type: "environment",
    id: "room",
    icon: RoomIcon,
    label: "Rooms",
    data: dataRoom,
  },
  {
    type: "environment",
    id: "Wall",
    icon: WallIcon,
    label: "Wall",
    data: dataWall,
  },
  {
    type: "environment",
    id: "Floor",
    icon: FloorIcon,
    label: "Floor",
    data: dataFloor,
  },
  {
    type: "environment",
    id: "Background",
    icon: BackgroundIcon,
    label: "Background",
    data: dataBackground,
  },

  // {
  //   type: "interior",
  //   id: "sofa",
  //   icon: SofaIcon,
  //   label: "Sofas",
  //   data: dataSofa,
  //   search: true,
  //   sort: true,
  //   filter: ["Black color", "White color"],
  // },
  // {
  //   type: "interior",
  //   id: "bed",
  //   icon: BedIcon,
  //   label: "Beds",
  //   data: dataBed,
  //   search: true,
  //   sort: true,
  //   filter: ["Black color", "White color"],
  // },
  // {
  //   type: "interior",
  //   id: "storage",
  //   icon: StorageIcon,
  //   label: "Storage",
  //   data: dataStorage,
  //   search: true,
  //   sort: true,
  //   filter: ["Black color", "White color"],
  // },
  // {
  //   type: "interior",
  //   id: "table",
  //   icon: TableIcon,
  //   label: "Tables",
  //   data: dataTable,
  //   search: true,
  //   sort: true,
  //   filter: ["Black color", "White color"],
  // },
  // {
  //   type: "interior",
  //   id: "chair",
  //   icon: ChairIcon,
  //   label: "Chairs",
  //   data: dataChair,
  //   search: true,
  //   sort: true,
  //   filter: ["Black color", "White color"],
  // },
  // {
  //   type: "interior",
  //   id: "light",
  //   icon: LightIcon,
  //   label: "Lights",
  //   data: dataLight,
  //   search: true,
  //   sort: true,
  //   filter: ["Black color", "White color"],
  // },
  // {
  //   type: "interior",
  //   id: "plant",
  //   icon: PlantIcon,
  //   label: "Plants",
  //   data: dataPlant,
  //   search: true,
  //   sort: true,
  //   filter: ["Black color", "White color"],
  // },
  // {
  //   type: "interior",
  //   id: "decor",
  //   icon: DecorIcon,
  //   label: "Decor",
  //   data: dataDecor,
  //   search: true,
  //   sort: true,
  //   filter: ["Black color", "White color"],
  // },
];
const {
  REACT_APP_NODE_ENV_KEY,
} = process.env;

export const MOCK_ORGANIZATION_ID = REACT_APP_NODE_ENV_KEY === "production"
  ? 5
  : 2;

export const resolutionList: resolutionListT[] = [
  {
    value: {
      width: 16,
      height: 9,
    },
    label: "16x9",
    id: 0,
  },
  {
    value: {
      width: 21,
      height: 9,
    },
    label: "21x9",
    id: 1,
  },
  {
    value: {
      width: 16,
      height: 10,
    },
    label: "16x10",
    id: 2,
  },
  {
    value: {
      width: 4,
      height: 3,
    },
    label: "4x3",
    id: 3,
  },
  {
    value: {
      width: 1,
      height: 1,
    },
    label: "1x1",
    id: 4,
  },
  {
    value: {
      width: 3,
      height: 4,
    },
    label: "3x4",
    id: 5,
  },
  {
    value: {
      width: 9,
      height: 16,
    },
    label: "9x16",
    id: 6,
  },
  {
    value: {
      width: 10,
      height: 16,
    },
    label: "10x16",
    id: 7,
  },
  {
    value: {
      width: 9,
      height: 21,
    },
    label: "9x21",
    id: 8,
  },
];

export type QualityType =
  | "Full HD"
  | "2k"
  | "4k"
  | "8k"
  | "16k"
  | "32k"
  | "64k"
  | "128k"
  | "256k"
  | "512k"
  | "1024k";

export const qualityBaseWidths: Record<QualityType, number> = {
  "Full HD": 1920,
  "2k": 2560,
  "4k": 3840,
  "8k": 7680,
  "16k": 15360,
  "32k": 30720,
  "64k": 61440,
  "128k": 122880,
  "256k": 245760,
  "512k": 491520,
  "1024k": 983040,
};
